import {loadSettings} from '@/modules/settings/api'

const BookingStore = {
  state: {
    settings: {}
  },
  getters: {
    globalSettings: state => state.settings
  },
  mutations: {
    SET_SETTINGS: (state, settings) => state.settings = settings
  },
  actions: {
    async LoadSettings(context) {
      let settings = await loadSettings()
      context.commit('SET_SETTINGS', settings)
    }
  }
}

export default BookingStore



// WEBPACK FOOTER //
// ./src/modules/settings/store.js